import React from 'react'
import icon from './svgs/shieldkeyhole.svg'
import { BaseIcon } from './_base'

export const ShieldKeyIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
